import ReportingAdd from './container';

export default ReportingAdd;
